(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/utils/assets/javascripts/wager-presentation.js') >= 0) return;  svs.modules.push('/components/pool-betting/utils/assets/javascripts/wager-presentation.js');
"use strict";

var _svs;

const {
  multiDrawsSystemTextLobby = ''
} = ((_svs = svs) === null || _svs === void 0 || (_svs = _svs.moduleBuilder) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 ? void 0 : _svs.myBets) || {};
const {
  SystemTypePresentation,
  WagerSystemTypes
} = svs.components.sport.tipsenShared.constants;
const {
  Currency: formatCurrency
} = svs.utils.format;
const {
  productIds
} = svs.utils.products;
const composeWagerDescription = _ref => {
  let {
    productId,
    description,
    systemType,
    isCompetitionWager,
    isUserBoards,
    rowCount
  } = _ref;
  let processedDescription = '';
  if (productId === productIds.BOMBEN) {
    if (systemType === WagerSystemTypes.RSYS) {
      processedDescription = "Reducerat ".concat(description);
    } else {
      processedDescription = description;
    }
  } else {
    processedDescription = description;
    if (systemType === WagerSystemTypes.MSYS) {
      processedDescription = isCompetitionWager || isUserBoards ? "M-system (".concat(rowCount, " st)") : "".concat(rowCount, " rader");
    }
  }
  if (typeof processedDescription === 'string' && processedDescription.includes(rowCount.toString())) {
    processedDescription = processedDescription.replace(rowCount.toString(), formatCurrency(rowCount.toString()));
  }
  return processedDescription;
};
const getIconBySystemType = _ref2 => {
  var _SystemTypePresentati;
  let {
    isCompetitionWager,
    isGroup,
    isUserBoards,
    groupName,
    productId,
    rowCount,
    systemType,
    multiDraw
  } = _ref2;
  if (isCompetitionWager) {
    return 'trophy-tips-sm';
  }
  if (isGroup || groupName) {
    return 'spela-tillsammans';
  }
  const {
    totalDrawCount,
    completedDrawCount
  } = multiDraw;
  if (totalDrawCount && totalDrawCount > 1 && totalDrawCount !== completedDrawCount) {
    return 'calendar';
  }
  if (productId === productIds.BOMBEN) {
    if (rowCount === 1 && systemType !== WagerSystemTypes.RSYS) {
      return SystemTypePresentation.MSYS.icon;
    }
    if (systemType === WagerSystemTypes.SROW && !isUserBoards) {
      return SystemTypePresentation.PIX.icon;
    }
  }
  return (_SystemTypePresentati = SystemTypePresentation[systemType]) === null || _SystemTypePresentati === void 0 ? void 0 : _SystemTypePresentati.icon;
};
const getSystemType = _ref3 => {
  var _boards$betProperties, _boards$betProperties2;
  let {
    productId,
    boards = {}
  } = _ref3;
  if ((_boards$betProperties = boards.betProperties) !== null && _boards$betProperties !== void 0 && _boards$betProperties.includes(WagerSystemTypes.REDUCERA_FRITT)) {
    return WagerSystemTypes.REDUCERA_FRITT;
  }

  if (productId === productIds.BOMBEN && (_boards$betProperties2 = boards.betProperties) !== null && _boards$betProperties2 !== void 0 && _boards$betProperties2.includes(WagerSystemTypes.XPERTEN)) {
    return WagerSystemTypes.SROW;
  }
  return boards.systemType;
};
const getTextBySystemType = _ref4 => {
  var _SystemTypePresentati2;
  let {
    competitionDesc,
    groupId,
    isCompetitionWager,
    isGroup,
    isUserBoards,
    marketplaceGroups,
    multiDraw,
    productId,
    rowCount,
    systemType
  } = _ref4;
  const {
    totalDrawCount,
    completedDrawCount
  } = multiDraw;
  if (isCompetitionWager && competitionDesc) {
    return competitionDesc !== null && competitionDesc !== void 0 ? competitionDesc : 'Tävling';
  }
  if (isGroup && marketplaceGroups !== null && marketplaceGroups !== void 0 && marketplaceGroups.isSuccess) {
    var _correctGroup$;
    const correctGroup = [];
    marketplaceGroups === null || marketplaceGroups === void 0 || marketplaceGroups.data.forEach(group => {
      if (group.groupId === groupId) {
        correctGroup.push(group);
      }
    });
    if ((_correctGroup$ = correctGroup[0]) !== null && _correctGroup$ !== void 0 && _correctGroup$.name) {
      return correctGroup[0].name;
    }
    return 'Spela tillsammans';
  } else if (isGroup && marketplaceGroups !== null && marketplaceGroups !== void 0 && marketplaceGroups.isError) {
    return 'Spela tillsammans';
  }
  if (isGroup && marketplaceGroups !== null && marketplaceGroups !== void 0 && marketplaceGroups.isError) {
    return 'Spela tillsammans';
  }
  if (isUserBoards) {
    return 'Externa systemspel';
  }
  if (totalDrawCount && totalDrawCount > 1) {
    if (totalDrawCount !== completedDrawCount) {
      const currentWeek = completedDrawCount + 1;
      return "".concat(multiDrawsSystemTextLobby, " (").concat(currentWeek, " av ").concat(totalDrawCount, ")");
    }
    if (totalDrawCount === completedDrawCount) {
      return multiDrawsSystemTextLobby;
    }
    return multiDrawsSystemTextLobby;
  }
  if (productId === productIds.BOMBEN || productId === productIds.MATCHEN) {
    if (systemType === WagerSystemTypes.RSYS) {
      return 'Reducerat';
    }
    if (rowCount === 1) {
      return SystemTypePresentation.MSYS.text;
    }
    if (systemType === WagerSystemTypes.SROW) {
      return SystemTypePresentation.PIX.text;
    }
  }
  return (_SystemTypePresentati2 = SystemTypePresentation[systemType]) === null || _SystemTypePresentati2 === void 0 ? void 0 : _SystemTypePresentati2.text;
};
setGlobal('svs.components.poolBetting.utils.wagerPresentation', {
  composeWagerDescription,
  getIconBySystemType,
  getSystemType,
  getTextBySystemType
});

 })(window);